var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTiktok22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H18C20.2091 0 22 1.79086 22 4V18C22 20.2091 20.2091 22 18 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8229 4.5H11.4553V13.3551C11.4553 14.4102 10.5447 15.2768 9.41147 15.2768C8.27825 15.2768 7.36762 14.4102 7.36762 13.3551C7.36762 12.3188 8.25801 11.471 9.35077 11.4333V9.21015C6.94266 9.24782 5 11.0754 5 13.3551C5 15.6536 6.98314 17.5 9.43172 17.5C11.8803 17.5 13.8634 15.6348 13.8634 13.3551V8.81448C14.7538 9.41739 15.8465 9.77536 17 9.79421V7.57102C15.2192 7.51449 13.8229 6.15797 13.8229 4.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTiktok22);
export default __webpack_public_path__ + "static/media/logo-tiktok-22.a891ac67a6b87b6f6e1e6bd412e26266.svg";
export { ForwardRef as ReactComponent };